import axios from 'axios'

export default {
    namespaced: true,
    state: {
        listWorks: []
    },
    mutations: {
        FETCH_LIST_WORKS(state, payload) {
            state.listWorks = payload
        },
        ADD_LIST_WORKS(state, payload) {
            state.listWorks.push(payload)
        },
        EDIT_LIST_WORKS(state, payload) {
            const index = state.listWorks.findIndex(
                item => item.id === payload.id
            )
            if (index !== -1) {
                Object.assign(state.listWorks[index], payload)
            }
        },
        DEL_WORK(state, item) {
            const index = state.listWorks.findIndex(
                list => list.id === item.id
            )
            state.listWorks.splice(index,1)
        }
    },
    actions: {
        fetch({commit, dispatch, state}, filter) {
            return new Promise((resolve, reject) => {
                if (state.listWorks.length) {
                    resolve(state.listWorks)
                } else {
                    axios.get(
                        '/api/root/staff-list-works/list',
                        {params: filter}
                    ).then(({data}) => {
                        commit('FETCH_LIST_WORKS', data.data)
                        resolve(data.data)
                    }).catch(error => {
                        dispatch('checkUnauthenticated', error, {root: true})
                        reject(error)
                    })
                }
            })
        },
        edit({dispatch, commit}, editedItem) {
            return new Promise((resolve) => {
                axios.put(
                    '/api/root/staff-list-works/edit/' + editedItem.id,
                    prepareData(editedItem)
                ).then(({data}) => {
                    commit('EDIT_LIST_WORKS', data.data)
                    resolve(data.data)
                }).catch(error => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        add({commit, dispatch}, data) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/root/staff-list-works/add',
                    prepareData(data)
                ).then(({data}) => {
                    commit('ADD_LIST_WORKS', data.data)
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        delete({dispatch, commit}, itemId) {
            return new Promise((resolve) => {
                axios.delete(
                    '/api/root/staff-list-works/dell/' + itemId
                ).then(({data}) => {
                    commit('DEL_WORK', data.data)
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        }
    }
}
function prepareData (data) {
    return {
        name: data.name,
        type: data.type,
        user_role_id: data.user_role_id,
        uid: data.uid,
        hotel_id: data.hotel_id,
    }
}
